import { ChevronDown, Search, X } from "lucide-react";

export const normText = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ł/g, "l");

export const SearchInput = ({ value, onChange, testid, placeholder = "Szukaj zawodnika lub klubu…" }) => (
  <div className="relative w-full">
    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
    <input data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
      className="w-full h-12 pl-9 pr-10 rounded-xl bg-[#1C2541] border border-blue-500/30 focus:border-blue-500 outline-none text-base" />
    {value && <button data-testid={`${testid}-clear`} onClick={() => onChange("")} className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>}
  </div>
);

export const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort((a, b) => a.localeCompare(b, "pl", { numeric: true }));

export const FilterSelect = ({ value, onChange, options, placeholder, testid, className = "" }) => (
  <div className={`relative ${className}`}>
    <select
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`appearance-none w-full h-11 pl-3 pr-9 rounded-xl bg-[#1C2541] border text-sm outline-none focus:border-blue-500 transition-colors ${value ? "border-blue-500/60 text-white" : "border-blue-500/20 text-slate-400"}`}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
    <ChevronDown className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" />
  </div>
);
